<template>
    <div>

        <main role="main">

            <div class="container">

                <div class="row mb-5">

                    <div class="col-md-12">

                        <b-breadcrumb :items="breadcrumbItems"></b-breadcrumb>

                        <h2 class="mb-5">
                            {{$t('text.properties.metadata')}}
                        </h2>

                        <button id="createPropertyButton1" class="btn btn-primary" @click="$bvModal.show('modal-property-entry')">{{$t('text.properties.createMetadata')}}</button>
                        <br>
                        <br>


                        <vue-good-table
                                styleClass="vgt-table table table-hover table-striped"
                                :columns="columns"
                                :rows="rows"
                                @on-row-click="onRowClick"
                                :key="tableKey"

                        >
                            <div slot="emptystate">
                                <div class="text-center"><i class="fa fa-exclamation-triangle"></i> <em>{{$t('text.globals.noData')}}</em></div>
                            </div>
                            <template slot="table-row" slot-scope="props">
                                <span v-if="props.column.field == 'action'">
                                    <b-dropdown id="dropdown-1" text="Action" variant="primary" class="m-md-2">
                                        <b-dropdown-item>{{$t('text.globals.edit')}}</b-dropdown-item>
                                        <b-dropdown-item>{{$t('text.globals.delete')}}</b-dropdown-item>
                                    </b-dropdown>
                                </span>
                            </template>
                        </vue-good-table>

                        <b-modal
                                centered
                                size="lg"
                                id="modal-property-entry"
                                :title="$t('text.properties.propertyCreateModal.title')"
                        >
                            <b-container>
                                <PropertyEntry :edit-property="false"/>
                            </b-container>
                            <div slot="modal-footer" class="w-100">
                                <b-button id="previousButton1" variant="secondary" class="float-left mr-0" @click="$bvModal.hide('modal-property-entry');resetProperty()">
                                    {{$t('text.globals.back')}}
                                </b-button>
                                <b-button id="saveButton1" variant="primary" class="float-right mr-0" @click="addNewProperty()">{{$t('text.globals.accept')}}</b-button>
                            </div>
                        </b-modal>
                        <b-modal
                                centered
                                size="lg"
                                id="modal-property-edit"
                                :title="$t('text.properties.propertyEditModal.title')"
                        >
                            <b-container>
                                <PropertyEntry :edit-property="true" :property-to-edit="propertyToEdit"/>
                            </b-container>
                            <div slot="modal-footer" class="w-100">
                                <b-button id="previousButton2" variant="secondary" class="float-left mr-0" @click="resetEditedProperty();$bvModal.hide('modal-property-edit');">
                                    {{$t('text.globals.back')}}
                                </b-button>
                                <b-button id="saveButton2" variant="primary" class="float-right mr-0" @click="setEditedProperty();$bvModal.hide('modal-property-edit')">{{$t('text.globals.accept')}}</b-button>
                            </div>
                        </b-modal>

                        <b-modal
                                centered
                                size="lg"
                                id="modal-property-delete"
                                :title="$t('text.properties.propertyDeleteModal.title')"
                        >
                            <b-container>
                                {{$t('text.properties.propertyDeleteModal.prompt')}}
                            </b-container>
                            <div slot="modal-footer" class="w-100">
                                <b-button id="previousButton3" variant="secondary" class="float-left mr-0" @click="$bvModal.hide('modal-property-delete');">
                                    {{$t('text.globals.back')}}
                                </b-button>
                                <b-button id="saveButton3" variant="primary" class="float-right mr-0" @click="rows.splice(indexOfEdited, 1);$bvModal.hide('modal-property-delete')">{{$t('text.globals.accept')}}</b-button>
                            </div>
                        </b-modal>




                    </div>
                </div>
            </div>

        </main>

    </div>
</template>

<script>

    import SidebarNavigation from "../components/SidebarNavigation";
    import PropertyEntry from "../components/PropertyEntry";

    export default {
        name: "Properties",
        components: {
            SidebarNavigation,
            PropertyEntry,
        },


        props: {
            properties: Object,
            aspects: Object,
            prefix: String,
        },

        data() {
            return {
                tableKey: 1,
                breadcrumbItems: [
                    {
                        text: this.$t('text.globals.adminTools'),
                        href: '#/admin-tools',
                    },
                    {
                        text: this.$t('text.properties.models'),
                        href: '#/models',
                        props: this.rows
                    },
                    {
                        text: this.$t('text.properties.aspects'),
                        to: {
                            name: 'Aspects',
                            params: {aspects: this.aspects, prefix: this.prefix}
                        }
                    },

                    {
                        text: this.$t('text.properties.metadata'),
                        active: true
                    }
                ],

                columns: [
                    {
                        label: this.$t('text.properties.name'),
                        field: 'name',
                        type: 'text',
                        sortable: true,
                    },
                    {
                        label: this.$t('text.properties.namespace'),
                        field: 'displayLabel',
                        type: 'text',
                        sortable: true,
                    },
                    {
                        label:  this.$t('text.properties.dataType'),
                        field: 'dataType',
                        type: 'text',
                        sortable: true,
                    },

                    {
                        label: this.$t('text.properties.requirement'),
                        field: 'requirement',
                        type: 'text',
                        sortable: true,
                    },

                    {
                        label: this.$t('text.properties.action'),
                        field: 'action',
                    }
                ],

                rows: [],
                newProperty: {
                    name: null,
                    displayLabel: null,
                    description: null,
                    dataType: null,
                    requirement: null,
                    multiple: null,
                    defaultValue: null,
                    constraint: null,
                    indexing: null,
                    constraintProps: {
                        regularExpression: null,
                        minimumLength: null,
                        maximumLength: null,
                        minimumValue: null,
                        maximumValue: null,
                        listOfValues: null,
                        javaClass: null,
                    }

                },

                toEdit: false,
                propertyToEdit: null,
                propertyToEditCopy: null,
                indexOdEdited: 0,
                rowKey: -1,



            }
        },

        mounted() {
            console.log(this.properties);
            this.setProperties();
            this.$root.$on("pushPropertyToList", payload => {
                console.log("pushPropertyToList");
                console.log(payload);
                console.log(this.rows);
                this.rows.push(_.cloneDeep(payload));
                console.log(this.rows);
                this.tableKey ++;
            });


            this.$root.$on("updateProperty", payload => {
                console.log(payload);
                console.log("updateProperty");
                this.rows[this.indexOdEdited] = _.cloneDeep(payload);
                this.tableKey++;
            })

        },

        methods: {

            addNewProperty() {
                console.log("potrdi");
                this.$root.$emit("addNewProperty", 50);
                this.$bvModal.hide("modal-property-entry");
            },

            setProperties() {
                let properties = this.properties.entry.properties;
                console.log(properties);
                for(let i = 0; i < properties.length; i ++) {
                    let element = {name: null, displayLabel: null, dataType: null, requirement: null, defaultValue: null, multivalued: null, indexed: null};
                    element.name = properties[i].prefixedName;
                    element.displayLabel = properties[i].title;
                    element.dataType = properties[i].dataType;
                    element.indexed = properties[i].indexed;
                    if(properties[i].multiValued === true) {
                        element.multiValued = this.$t('text.properties.yes');
                    }
                    else {
                        element.multiValued = this.$t('text.properties.no');
                    }
                    if(properties[i].mandatory === true || properties[i].mandatoryEnforced === true) {
                        element.requirement = this.$t('text.properties.mandatory');
                    }

                    else {
                        element.requirement = this.$t('text.properties.optional');
                    }

                    if(element.dataType === "d:boolean") {
                        element.defaultValue = this.$t('text.properties.false');
                    }
                    else {
                        element.defaultValue = "";
                    }
                    this.rows.push(element);

                }
            },

            resetProperty() {
                this.$root.$emit("resetProperty");
            },

            onRowClick(params) {
                //console.log(params);
                let a = params.event.originalTarget.childNodes[0].data; //check if element is from dropdown, so we can prevent the router.push if the element is from dropdown
                console.log(a);
                if(a === this.$t('text.globals.edit')) {
                    this.propertyToEdit = params.row;
                    this.propertyToEditCopy = _.cloneDeep(this.propertyToEdit);
                    this.indexOfEdited = params.pageIndex;
                    this.toEdit = true;
                    this.$root.$emit("setEditProperty", this.propertyToEdit);
                    this.$bvModal.show("modal-property-edit");
                }

                if(a ===  this.$t('text.globals.delete')) {
                    let indexOfEditing = params.pageIndex;
                    this.$bvModal.show("modal-property-delete");
                }

                else {
                    this.propertyToEdit = params.row;
                    this.propertyToEditCopy = _.cloneDeep(this.propertyToEdit);
                    this.indexOfEdited = params.pageIndex;
                    this.toEdit = true;
                    this.$root.$emit("setEditProperty", this.propertyToEdit);
                    this.$bvModal.show("modal-property-edit");
                }
            },


            setEditedProperty() {
                this.$root.$emit("setEditedPropertyUpdated");
            },

            resetEditedProperty() {
                console.log("resetEdited shit");
                console.log(this.propertyToEditCopy);
                this.propertyToEdit = _.cloneDeep(this.propertyToEditCopy);
                this.rows[this.indexOfEdited] = _.cloneDeep(this.propertyToEdit);
                this.tableKey++;
            },

        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/Properties.vue